/* ATY · Fiche produit : choix de taille/couleur, galerie, barre collante, guide des tailles */
(function () {
  'use strict';

  var DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

  function init(root) {
    if (!root || root._atyPdp) return;
    root._atyPdp = true;

    var dataEl = root.querySelector('[data-aty-pdp-data]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { variants: [] }; }
    var variants = data.variants || [];
    var picker = root.querySelector('[data-aty-picker]');
    var sets = picker ? Array.prototype.slice.call(picker.querySelectorAll('[data-opt]')) : [];
    var idInput = root.querySelector('[data-aty-id]');
    var atc = root.querySelector('[data-aty-atc]');
    var atcLabel = root.querySelector('[data-aty-atclabel]');
    var atcText = atcLabel ? atcLabel.textContent.trim() : 'Ajouter au panier';
    var dyn = root.querySelector('[data-aty-dyn]');
    var need = root.querySelector('[data-aty-need]');
    var form = root.querySelector('form[data-type="add-to-cart-form"]');

    /* ---------- variantes ---------- */
    function selected() {
      return sets.map(function (fs) {
        var r = fs.querySelector('input:checked');
        return r ? r.value : null;
      });
    }
    function findVariant(sel) {
      if (sel.some(function (v) { return v === null; })) return null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) if (variants[i].options[j] !== sel[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    function markAvailability(sel) {
      sets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (input) {
          var label = fs.querySelector('label[for="' + input.id + '"]');
          var avail = variants.some(function (v) {
            if (!v.available || v.options[i] !== input.value) return false;
            for (var j = 0; j < sel.length; j++) {
              if (j !== i && sel[j] !== null && v.options[j] !== sel[j]) return false;
            }
            return true;
          });
          if (label) label.classList.toggle('is-out', !avail);
        });
      });
    }
    function setText(sel, txt) {
      var el = root.querySelector(sel);
      if (el) el.textContent = txt;
    }
    function update(fromUser) {
      var sel = selected();
      sets.forEach(function (fs, i) {
        var b = fs.querySelector('[data-aty-optval]');
        if (b) b.textContent = sel[i] || '';
        var colon = b && b.parentNode.firstChild;
        if (colon && colon.nodeType === 3) colon.textContent = colon.textContent.replace(/\s*:?\s*$/, sel[i] ? ' : ' : ' ');
      });
      markAvailability(sel);
      var v = findVariant(sel);
      root._atyVariant = v;

      if (idInput) idInput.value = v ? v.id : '';
      if (dyn) dyn.classList.toggle('is-locked', !v || !v.available);
      if (need && v) need.hidden = true;

      if (atc) {
        if (!v && sel.some(function (x) { return x === null; })) {
          atc.disabled = false;
          if (atcLabel) atcLabel.textContent = atcText;
        } else if (!v || !v.available) {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = v ? 'Épuisé' : 'Indisponible';
        } else {
          atc.disabled = false;
          atc.removeAttribute('aria-disabled');
          if (atcLabel) atcLabel.textContent = atcText;
        }
      }

      if (v) {
        var dur = root.querySelector('[data-aty-dur][data-opt]');
        if (dur) {
          var dl = String(v.options[Number(dur.getAttribute('data-opt'))] || '').split('(')[0].trim();
          dur.textContent = dl;
          var ll = dl.toLowerCase(), n = parseInt(ll, 10) || 0, mo = /\ban/.test(ll) ? n * 12 : (/jour|semaine/.test(ll) ? 0 : n);
          dur.className = 'aty-badge aty-badge--dur aty-dur--' + (mo >= 12 ? 'gold' : mo >= 6 ? 'dark' : mo >= 3 ? 'accent' : 'soft');
          dur.hidden = !n;
        }
        setText('[data-aty-price]', v.price);
        setText('[data-aty-barprice]', v.price);
        var now = root.querySelector('[data-aty-price]');
        if (now) now.classList.toggle('is-sale', !!v.compare);
        var was = root.querySelector('[data-aty-compare]');
        if (was) { was.hidden = !v.compare; was.textContent = v.compare || ''; }
        var save = root.querySelector('[data-aty-save]');
        if (save) {
          save.hidden = !v.compare;
          setText('[data-aty-pct]', String(v.pct));
          setText('[data-aty-saveamt]', v.save || '');
        }
        var stock = root.querySelector('[data-aty-stock]');
        if (stock) {
          var low = data.stockBadge && v.available && v.qty !== null && v.qty > 0 && v.qty <= data.threshold;
          stock.hidden = !low;
          if (low) setText('[data-aty-stocktxt]', v.qty === 1 ? 'Dernière pièce dans cette taille' : 'Plus que ' + v.qty + ' pièces dans cette taille');
        }
        if (fromUser) {
          if (window.history && history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            history.replaceState({}, '', url.toString());
          }
          if (v.media) goToMedia(v.media);
        }
      } else {
        var st = root.querySelector('[data-aty-stock]');
        if (st) st.hidden = true;
      }
      updateWhatsapp(v, sel);
    }

    if (picker) {
      picker.addEventListener('change', function (e) {
        if (e.target.matches('.aty-pdp__radio')) update(true);
      });
    }

    /* Taille obligatoire : on bloque l'envoi tant qu'elle n'est pas choisie */
    function askSize() {
      if (need) need.hidden = false;
      var target = root.querySelector('.aty-pdp__opt.is-size') || picker;
      if (target) {
        target.classList.remove('is-shake');
        void target.offsetWidth;
        target.classList.add('is-shake');
        var r = target.getBoundingClientRect();
        if (r.top < 80 || r.bottom > window.innerHeight) window.scrollTo({ top: window.scrollY + r.top - 120, behavior: 'smooth' });
      }
    }
    root.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!idInput || !idInput.value) {
        e.preventDefault();
        e.stopPropagation();
        askSize();
      }
    }, true);
    if (dyn) {
      dyn.addEventListener('click', function (e) {
        if (dyn.classList.contains('is-locked')) { e.preventDefault(); e.stopPropagation(); askSize(); }
      }, true);
    }

    /* ---------- WhatsApp ---------- */
    function updateWhatsapp(v, sel) {
      var wa = root.querySelector('[data-aty-wa]');
      if (!wa) return;
      var opts = [];
      sets.forEach(function (fs, i) {
        var lg = fs.querySelector('.aty-pdp__legend span');
        var nm = lg ? lg.firstChild.textContent.replace(/\s*:?\s*$/, '') : '';
        opts.push(nm + ' ' + (sel[i] || '?'));
      });
      var price = v ? v.price : (root.querySelector('[data-aty-price]') || {}).textContent || '';
      var msg = (wa.getAttribute('data-msg') || '')
        .replace('[produit]', wa.getAttribute('data-name') || '')
        .replace('[options]', opts.join(', ') || '-')
        .replace('[prix]', String(price).trim())
        .replace('[lien]', window.location.origin + root.getAttribute('data-url') + (v ? '?variant=' + v.id : ''));
      wa.href = 'https://wa.me/' + wa.getAttribute('data-aty-wa') + '?text=' + encodeURIComponent(msg);
    }

    /* ---------- galerie ---------- */
    var track = root.querySelector('[data-aty-track]');
    var dots = root.querySelectorAll('.aty-pdp__dot');
    var cur = root.querySelector('[data-aty-cur]');
    var mobile = window.matchMedia('(max-width: 989px)');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-aty-thumb]'));
    var prevBtn = root.querySelector('[data-aty-prev]');
    var nextBtn = root.querySelector('[data-aty-next]');
    function currentIndex() {
      if (!track || !slides.length) return 0;
      var x = track.scrollLeft, best = 0, bestD = Infinity;
      slides.forEach(function (sl, k) {
        var d = Math.abs(sl.offsetLeft - track.offsetLeft - x);
        if (d < bestD) { bestD = d; best = k; }
      });
      return best;
    }
    function goToIndex(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function markIndex(i) {
      if (cur) cur.textContent = String(i + 1);
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === Math.min(i, dots.length - 1)); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        if (k === i && t.parentNode && t.parentNode.scrollHeight > t.parentNode.clientHeight) {
          var box = t.parentNode;
          if (t.offsetTop < box.scrollTop || t.offsetTop + t.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTo({ top: t.offsetTop - 8, behavior: 'smooth' });
        }
      });
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToIndex(Number(t.getAttribute('data-aty-thumb'))); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goToIndex(Math.max(0, currentIndex() - 1)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToIndex(Math.min(slides.length - 1, currentIndex() + 1)); });
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          markIndex(currentIndex());
        });
      }, { passive: true });
    }
    function goToMedia(mediaId) {
      if (!track) return;
      var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      goToIndex(slides.indexOf(slide));
    }

    /* ---------- photos en grand ---------- */
    var lb = root.querySelector('[data-aty-lb]');
    root.addEventListener('click', function (e) {
      var z = e.target.closest('[data-aty-zoom]');
      if (z && lb && typeof lb.showModal === 'function') {
        lb.showModal();
        document.documentElement.classList.add('aty-noscroll');
        var img = lb.querySelector('img[data-index="' + z.getAttribute('data-aty-zoom') + '"]');
        if (img) img.scrollIntoView({ block: 'start' });
        return;
      }
      var o = e.target.closest('[data-aty-open]');
      if (o) {
        var dlg = document.getElementById(o.getAttribute('data-aty-open'));
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); document.documentElement.classList.add('aty-noscroll'); }
        return;
      }
      var c = e.target.closest('[data-aty-close]');
      if (c) { var d = c.closest('dialog'); if (d) d.close(); return; }
      if (e.target.tagName === 'DIALOG') e.target.close();
    });
    root.querySelectorAll('dialog').forEach(function (d) {
      d.addEventListener('close', function () { document.documentElement.classList.remove('aty-noscroll'); });
    });

    /* ---------- date de livraison ---------- */
    var eta = root.querySelector('[data-aty-eta]');
    if (eta) {
      try {
        var min = parseInt(eta.getAttribute('data-min'), 10) || 0;
        var max = parseInt(eta.getAttribute('data-max'), 10) || min;
        var DAYMAP = { dimanche: 0, lundi: 1, mardi: 2, mercredi: 3, jeudi: 4, vendredi: 5, samedi: 6, sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };
        var closed = {};
        String(eta.getAttribute('data-closed') || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(/[,;\s]+/).forEach(function (w) {
          if (w && DAYMAP.hasOwnProperty(w)) closed[DAYMAP[w]] = true;
        });
        if (Object.keys(closed).length > 6) closed = {};
        /* Jours de livraison = jours ouverts après aujourd'hui (fuseau d'Abidjan = GMT) */
        var add = function (n) {
          var now = new Date();
          var d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
          var k = 0;
          while (k < n) { d.setUTCDate(d.getUTCDate() + 1); if (!closed[d.getUTCDay()]) k++; }
          while (closed[d.getUTCDay()]) d.setUTCDate(d.getUTCDate() + 1);
          return d;
        };
        var label = function (d) {
          var now = new Date();
          var today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
          var diff = Math.round((d.getTime() - today) / 864e5);
          if (diff === 0) return "aujourd'hui";
          if (diff === 1) return 'demain';
          return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate();
        };
        var d1 = add(min), d2 = add(max);
        var txt = (eta.getAttribute('data-tpl') || '').replace('[debut]', label(d1, min)).replace('[fin]', label(d2, max));
        if (min === max) txt = txt.replace(/ ou [^ ]+( \d+)?/, '');
        var span = eta.querySelector('[data-aty-etatxt]');
        if (span && txt) span.innerHTML = txt.replace(label(d1, min), '<b>' + label(d1, min) + '</b>').replace(label(d2, max), '<b>' + label(d2, max) + '</b>');
      } catch (e) { /* texte de secours déjà affiché */ }
    }

    /* ---------- barre collante ---------- */
    var bar = root.querySelector('[data-aty-bar]');
    var buy = root.querySelector('[data-aty-buy]');
    if (bar && buy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          var btn = bar.querySelector('[data-aty-barbtn]');
          if (btn) btn.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(buy);
      bar.querySelector('[data-aty-barbtn]').addEventListener('click', function () {
        if (!idInput || !idInput.value) {
          askSize();
          return;
        }
        if (atc && !atc.disabled) atc.click();
      });
    }

    update(false);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-aty-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
